import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Button, Typography, Container, Grid, styled } from "@mui/material";
import dustbin from "../../images/dustbin.png";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { Box, IconButton } from "@mui/material";
import { Autocomplete, TextField, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { toast } from "react-toastify";
import DialogComponent from "../reusableComponents/Dialog";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import TableComponent from "../reusableComponents/Table";
import { mutateItems, P1, P2, P3, P4, saleWarhouse } from "./httpCalls";
import { getBillNumber } from "./httpCalls";
import { useDispatch, useSelector } from "react-redux";
import { getVendors } from "../vendors/vendorSlice";
// import { getItems, saleItem } from "../inventory/itemsSlice";

import { removeSelected, addGst } from "./saleSlice";
import {
  addToSelectForPurchase,
  getItems,
  saleQuantity,
  unselectItems,
} from "../inventory/itemsSlice";
import AddItem from "../inventory/AddItem";
import { getWarehouseNumber, increaseWareNumber } from "./warenumSlice";
import {
  createLedger,
  createLedgerEntry,
  updateSaleLedger,
} from "../ledgers/httpCalls";
import { createQuotation } from "../quotation/httpCalls";
import { createBill, saveInBank, saveInCashInHand } from "../bills/httpCalls";
import { sendEmailNotification } from "../bills/httpCalls";
import { v4 as uuidv4 } from "uuid";
import LedgersRepository from "../../Repository/LedgersRepository";
import BillPreview from "../reusableComponents/BillPreview";
import DefaultRepository from "../../Repository/DefaultRepository";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { RFTfeature } from "../features/RFTfeature";
import { getQty } from "../../utils/getQty";
import { BoxesPacking } from "../features/BoxesPacking";
import {
  clearLedgersNames,
  getLedgersNames,
  getLedgersNamesRegions
} from "../ledgers/ledgersNamesSlice";
import { Toast } from "../components/Toast";
import { getUnits } from "../units/unitSlice";
import TabOrderComponent from "./TabOrderComponent";
import { BtnBack, BtnHeader, HeadBox, RowBox, SubTitle } from "./styles";
import { BtnHistory, BtnQuote, ClickAreaBox, GridBox } from "./styles";
import BillPreviewUpdated from "../reusableComponents/BillPreview/BillPreviewUpdated";
import BillsRepository from "../../Repository/BillsRepository";
import {
  saveBillToIndexedDB,
  getBillsFromIndexedDB,
  deleteBillFromIndexedDB,
} from "../point of sale/IndexDb";

import Repo from "../../Repository/Repo";
import { getBanksList } from "../../pages/bank/https";
import { ConstructionOutlined } from "@mui/icons-material";
function SellItem() {
  const gst = localStorage.getItem("gst") || "";
  const gstType = localStorage.getItem("gstType") || "";
  const income = localStorage.getItem("income") || "";
  const incomeType = localStorage.getItem("incomeType") || "";
  const further = localStorage.getItem("further") || "";
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedForSale = useSelector((state) => state.sale.selected);
  const vendors = useSelector((state) => state.vendor.vendors);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const inventory = useSelector((state) => state.inventory.items);
  const warehouseNumber = useSelector((state) => state.wareNum.warehouseNumber);
    const { company, companyLoading } = useSelector((state) => state.company);
  
  const currency = useSelector((state) => state.employee.currency);
  const templateType = localStorage.getItem("template");
  const [billNumber, setbillNumber] = useState(0);
  console.log("billNumber", billNumber);
  const tokenType = localStorage.getItem("tokenType");
  // let billoffline = localStorage.getItem("billCreated");
  // let billCreated = JSON.parse(billoffline)
  // console.log('nbiiiii', billCreated)
  const { units } = useSelector((state) => state.units);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isOfflineBills, setIsOfflineBills] = useState([]);
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    next_page_token: "",
    selectedAll: false,
    Total: 0,
    subTotal: 0,
    discount: "",
    discAmount: 0,
    discountType: "price",
    paid: 0,
    customer: "",
    notes: "",
    clearBalance: false,
    discountDialog: false,
    showBill: false,
    varTotal: 0,
    ledgerSelection: false,
    saleKhata: false,
    yourProfit: false,
    addModal: false,
    selectedVendor: "all",
    ledger_address: "",
    ledger_id: "new",
    idString: "new",
    new_ledger: {
      ledger_type: "customer",
      address: "",
      name: "",
      region: "",
    },
    batchNumber: "",
    formallyOutstandings: 0,
    propsBill: "",
    historyModal: false,
    itemHistory: [],
    saleType: "sale",
    saleby: "role",
    barCodeLoading: false,
    storeBill: false,
    bank: "",
    paymentMethod: "cash",
    cheque: 0,
    bankId: "",
  });
  console.log("ss", state.clearBalance);
  console.log("bankId", state.bankId);
  console.log("bank", state.bank);
  console.log(" state.paymentMethod",  state.paymentMethod);

 

  console.log("sss", state.storeBill);
  console.log("props", state.propsBill);
  const companyCode = localStorage.getItem("companyCode");
  const { status } = useSelector((state) => state.trial);
  const [banksList, setBanksList] = useState([]);

  console.log("sta", state);

  let type = "";
  // if (state.saleType == "service") {
  //   type = "serviceRFT";
  // } else if (state.saleType == "sale" && state.saleby == "rft") {
  //   type = "RFT";
  // } else {
  //   type = "Role";
  // }

  useEffect(() => {
    if (isOnline == true) {
      if (vendors?.length == 0) {
        dispatch(getVendors());
      }
      if (inventory?.length == 0) {
        dispatch(getItems());
      }
    const ledgerRegions =  JSON.parse(localStorage.getItem("ledgerRegions"))
    console.log("ledgerRegions",ledgerRegions)
    
      if (ledgersNames?.length == 0) {
        if(localStorage.getItem("tokenType") == "user" && ledgerRegions.length > 0 ) {
        
          dispatch(getLedgersNamesRegions());

        } else {
          dispatch(getLedgersNames());

        }
      }

      getBill();
      getBanksListHandler();

      // if (!billNumber) {
      //   dispatch(getBillNumber());
      // }
      if (warehouseNumber == "") {
        dispatch(getWarehouseNumber());
      }
      if (units?.length == 0) {
        dispatch(getUnits());
      }
    }
  }, []);

  useEffect(() => {
    if (isOnline == true) {
      getBillsFromIndexedDB()
        .then((billsarray) => {
          console.log("Bills:", billsarray);
          // const offlineBills=  billsarray.map((billslocal)=> {
          //     console.log('billlocal', billslocal)
          //    return billOffline(billslocal);
          //   })
          setIsOfflineBills(billsarray);
        })
        .catch((error) => {
          console.error("Error getting bills:", error);
        });
    }
  }, [isOnline]);
  useEffect(() => {
    const fetchBills = async () => {
      if (isOnline && isOfflineBills) {
        try {
          // const billsarray = await getBillsFromIndexedDB();
          // console.log('Bills:', billsarray);

          for (const billslocal of isOfflineBills) {
            console.log("Fetching bill number for:", billslocal);

            const billNum = await getBillNumber(); // Wait for getBillNumber to resolve
            console.log("Fetched bill number:", billNum);

            await billOffline(billslocal, billNum);
          }
        } catch (error) {
          console.error("Error getting bills:", error);
        }
      }
    };

    fetchBills();
  }, [isOnline, isOfflineBills]);

  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup function to remove the event listeners when the component unmounts
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    findPrice();
  }, [selectedForSale, state.discAmount]);

  const getBill = async () => {
    let data = await getBillNumber();
    setbillNumber(data);
  };
  const billOffline = (billslocal, billNum) => {
    let companyCode = localStorage.getItem("companyCode");
    // let billCreated = localStorage.getItem("billCreated");
    let gst =
      localStorage.getItem("gst") &&
      localStorage.getItem("gst") != "undefined" &&
      localStorage.getItem("gst") != "disabled"
        ? localStorage.getItem("gst")
        : "";
    let gstType = localStorage.getItem("gstType") || "";
    let saleType = RFTfeature() ? type : "";
    let billData = {
      company_code: localStorage.getItem("companyCode"),
      items: billslocal.items,
      date: billslocal.date,
      subTotal: billslocal.subTotal,
      discount: billslocal.discount,
      total: billslocal.total,
      billNumber: billNum,
      seller: localStorage.getItem("token"),
      customer: billslocal.customer,
      ledger_id: billslocal.ledger_id,
      change: parseInt(billslocal.change),
      paid: billslocal.paid,
      saleType: billslocal.saleType,
      discount_type: billslocal.discount_type,
      notes: billslocal.notes,
      warehouseBill: templateType == "warehouse" ? true : false,
    };
    // if (companyCode == 9478 || companyCode == 1495) {
    //   billData.gst = gst;
    //   billData.gstType = gstType;
    // }
    console.log("billllldatatatat", billData);
    return BillsRepository.billsModel({
      request: {
        method: "saveBills",
        data: {
          bill: billData,
        },
      },
    })
      .then((response) => {
        console.log("repsone", response);
        if (response.data.response.status.statusCode === 200) {
          // getBillNumber()
          deleteBillFromIndexedDB(billslocal.id)
            .then(() => {
              console.log("Bill deleted successfully!");
            })
            .catch((error) => {
              console.error("Error deleting bill:", error);
            });
        }
        return response;
      })
      .catch((error) => {
        console.error("Error saving bill:", error);
        throw error;
      });
  };
  const thermalPrintTypeHandler = () => {
    Repo.template({
      request: {
        method: "getTemplate",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then(({ data }) => {
      localStorage.setItem("template", data.response.data.template);
      console.log(data.response.data.template);
    });
  };

  useEffect(() => {
    thermalPrintTypeHandler();
  }, []);

  const historyToggle = () => {
    setState((pre) => ({ ...pre, historyModal: !pre.historyModal }));
    if (!state.historyModal) {
      getItemHistory();
    } else {
      setState((pre) => ({ ...pre, setItemHistory: [] }));
    }
  };
  const getItemHistory = () => {
    selectedForSale.forEach(async (each) => {
      let { data } = await LedgersRepository.ledgerModel({
        request: {
          method: "getLedgerHistory",
          data: {
            ledger_id: state.ledger_id,
            item_id: each.itemId,
          },
        },
      });
      setState((pre) => ({
        ...pre,
        itemHistory: [...pre.itemHistory, ...data.response.data.ledger_history],
      }));
    });
  };

  const handleBill = (argSell) => {
    // let saleType = RFTfeature() ? type : "";
    //  let saleType = RFTfeature() ? type : "";

    let thisDate = moment().format("DD-MM-YYYY");
    let obj = {
      billNumber: billNumber,
      customer: state.customer,
      items: selectedForSale,
      discount: state.discount,
      discount_type: state.discountType,
      created_at: "",
      date: thisDate,
      subTotal: state.subTotal.toFixed(3),
      total: getTotal(),
      paid: state.paid,
      // saleType: saleType,
      outstandingBalance: "",
      change: getTotal() - parseInt(state.paid),
      // change:parseInt(state.paid) > getTotal() ?  getTotal() : getTotal() - parseInt(state.paid),
      formallyOutstandings: state.formallyOutstandings,
      notes: state.notes,
      ledger_id: state.ledger_id,
      ledger_address: state.ledger_address,
      idString: state.idString,
      newLedgerName: state.new_ledger.name,
      printQuote: argSell,
      varTotal: state.varTotal,
      paymentMethod: state?.paymentMethod,
      bankName: state?.bank,
      cheque: state?.cheque,
      clearBalance: state.clearBalance,
    };
    let gst =
      localStorage.getItem("gst") &&
      localStorage.getItem("gst") != "undefined" &&
      localStorage.getItem("gst") != "disabled"
        ? localStorage.getItem("gst")
        : "";

    let income =
      localStorage.getItem("income") &&
      localStorage.getItem("income") != "undefined" &&
      localStorage.getItem("income") != "disabled"
        ? localStorage.getItem("income")
        : "";
    let further =
      localStorage.getItem("further") &&
      localStorage.getItem("further") != "undefined" &&
      localStorage.getItem("further") != "disabled"
        ? localStorage.getItem("further")
        : "";
    if (gst) {
      obj.gst = gst;
    }
    if (income) {
      obj.income = income;
    }
    if (income) {
      obj.further = further;
    }
    let gstType = localStorage.getItem("gstType") || "";
    if (gstType == "Bill") {
      obj.gstType = "Bill";
    } else if (gstType == "Item") {
      obj.gstType = "Item";
    }

    let incomeType = localStorage.getItem("incomeType") || "";
    if (incomeType == "income") {
      obj.incomeType = "income";
    }
    // else if (gstType == "Item") {
    //   obj.gstType = "Item";
    // }
    console.log("obb", obj.discount);
    console.log("grr", state.discount);

    setState((pre) => ({ ...pre, showBill: true, propsBill: obj }));
  };

  const findPrice = () => {
    let myTotal = 0;
    let gstAmount = 0;
    selectedForSale.map((item) => {
      let qty = item.saleQuantity ? Number(item.saleQuantity) : 1;
      let pr =
        // item.batchPricePerBox ? item.batchPricePerBox :
        // item.batchPricePerBox ?  item.batchPricePerBox :
        item.saleType == "pieces"
          ? Number(item.pricePerPiece || item.batchPricePerPiece)
          : Number(item.salePrice || item.price || item.batchPricePerBox);
      // ? Number(item.salePrice || item.batchPricePerPiece)
      // : Number(item.price || item.batchPricePerBox);

      console.log("prrrrrr", pr);
      let itemPrice = 0;
      let totalDiscount;
      if (item?.gstAmount) {
        itemPrice = Math.ceil((pr + item.gstAmount) * qty);
        gstAmount = item.gstAmount * qty;
      } else {
        console.log("prrr", pr);
        console.log("quant", qty);

        itemPrice = pr * qty;
      }
      let itemDiscount = item.saleDiscount
        ? item.saleDiscount
        : item.saleDiscount == ""
        ? item.saleDiscount
        : item.discount;
      if (itemDiscount) {
        let eachValue = (itemDiscount / 100) * Math.ceil(pr * qty);
        totalDiscount = eachValue;
      } else {
        totalDiscount = 0;
      }
      myTotal = myTotal + itemPrice - totalDiscount;
      console.log("tot", myTotal);
    });

    if (state.discount) {
      calculateDiscount(state.discount, state.discountType, state.subTotal);
      console.log("Ttotal", myTotal);
    }

    if ((gstType && gstType == "Bill") || income) {
      let tot = myTotal - state.discAmount;
      setState((pre) => ({
        ...pre,
        Total:
          tot +
          getGstAmount(tot) +
          getIncomeAmount(tot) +
          getFurtherAmount(tot),
        subTotal: myTotal - gstAmount,
      }));
    } else if (gstType && gstType == "Item") {
      setState((pre) => ({
        ...pre,
        Total: myTotal - state.discAmount,
        subTotal: myTotal - gstAmount,
      }));
    } else {
      setState((pre) => ({
        ...pre,
        Total: myTotal - state.discAmount,
        subTotal: myTotal,
      }));
    }
  };

  const getGstAmount = (val) => {
    if (gst && gst != "undefined" && gst != "disabled") {
      let gstAmount = (Math.ceil(gst) / 100) * Math.ceil(val);
      return gstAmount;
    } else {
      return 0;
    }
  };

  const getIncomeAmount = (val) => {
    if (income && income != "undefined" && income != "disabled") {
      let incomeAmount = (Math.ceil(income) / 100) * Math.ceil(val);
      return incomeAmount;
    } else {
      return 0;
    }
  };

  const getFurtherAmount = (val) => {
    if (further && further != "undefined" && further != "disabled") {
      let furtherAmount = (Math.ceil(further) / 100) * Math.ceil(val);
      return furtherAmount;
    } else {
      return 0;
    }
  };
  const sellQuotation = async () => {
    let change = parseInt(state.paid - state.Total);
    let copyItems = JSON.parse(JSON.stringify(selectedForSale));
    dispatch(unselectItems(selectedForSale));

    if (state.ledger_id == "new") {
      if (state.new_ledger.name) {
        if (state.new_ledger.name == "" || state.new_ledger.address == "") {
          toast.configure();
          toast.warn("Fill both ledger Name and Detail");
          return;
        }
        let data = await createLedger(state.new_ledger, dispatch);
        let paid = state.paid;
        let id = data.response.data.ledger;
        dispatch(removeSelected());
        createQuotation(state, id, change, copyItems, paid);
        history.push("/inventory/admin/quotations");
      } else {
        let paid = change >= 0 ? state.paid - change : state.paid;
        dispatch(removeSelected());
        createQuotation(state, "", change, copyItems, paid);
        history.push("/inventory/admin/quotations");
      }
    } else {
      let paid = change >= 0 ? state.paid - change : state.paid;
      dispatch(removeSelected());
      createQuotation(state, state.ledger_id, change, copyItems, paid);
      history.push("/inventory/admin/quotations");
    }
  };

  const sellItems = async () => {
    let thisDate = moment().format("DD-MM-YYYY");
    const billTemplate = localStorage.getItem("template");
    let copyItems = JSON.parse(JSON.stringify(selectedForSale));
    // if (RFTfeature()) {
    //   if (state.saleType == "service") {
    //     copyItems.forEach((item) => {
    //       let qty = parseFloat(item.saleQuantity / 328);
    //       let fivePercent = (5 / 100) * qty;
    //       item.saleQuantity = qty + fivePercent;
    //       item.fivePercent = fivePercent;
    //     });
    //   } else if (state.saleType == "sale" && state.saleby == "rft") {
    //     copyItems.forEach((item) => {
    //       let qty = parseFloat(item.saleQuantity / 328);
    //       item.saleQuantity = qty;
    //     });
    //   }
    // }
    let saveSales = [];
    let billItems = [];
    let ledgerHistories = [];
    let noti = [];
    let updatedItems = [];
    copyItems &&
      copyItems.forEach((item) => {
        console.log("item", item);
        let boxes = 0;
        let bonusQty = parseInt(item.bonus) || 0;

        if (BoxesPacking()) {
          if (item.saleQuantity && item?.packing) {
            boxes = parseFloat(item.saleQuantity) / item.packing;
          } else {
            boxes = 0;
          }
        }
        let qty = item.weightType ? item.weight : item.quantity;
        let minQuantity = item.minquantity
          ? item.minquantity
          : item.minQuantity;
        // let itemPrice = item.salePrice ? item.salePrice : item.price;
        let itemPrice;
        itemPrice =
          item.saleType == "pieces"
            ? Number(
                (item.salePrice ? item.salePrice : item.price) /
                  item.piecesPerBox
              ) || item.batchPricePerPiece
            : Number(item.salePrice ? item.salePrice : item.price) ||
              item.batchPricePerBox;

        let saleQty = item.saleQuantity ? item.saleQuantity : 1;
        console.log("jj", item.saleType);

        saleQty =
          item.box === true && item.saleType === "box" ? saleQty : saleQty;
        console.log("saleqty", saleQty);
        let costPricePieces;
        costPricePieces =
          item.saleType == "pieces"
            ? item.costPrice / item.piecesPerBox
            : item.costPrice;

        //  let saleTypeBox = "box";
        //  item.saleType = saleTypeBox
        let paid = state.paid;
        if(state.paid > state.Total ) {
          paid = state.Total
         }
        let sale = {
          timestamp: Math.floor(Date.now() / 1000),
          category: item.category,
          unit: item.unit,
          discount: state.discount || 0,
          read: "false",
          date: thisDate,
          company_code: companyCode,
          imgURL: item.imgURL,
          minQuantity: parseInt(minQuantity) || 0,
          quantity: Number(saleQty),
          description: item.description,
          itemId: item.itemId,
          name: item.name,
          totalPrice: parseFloat(itemPrice * saleQty) || 0,
          // totalProfit:
          //   parseFloat(state.paid) - parseFloat(costPricePieces * saleQty) || 0,
          totalProfit:
             parseFloat(paid) - parseFloat(costPricePieces * saleQty) || 0,
          price: parseInt(item.costPrice, 10) || 0,
          salePrice: itemPrice || 0,
          itemCode: item.itemCode,
          vendor: item.vendor,
          dateOfPurchase: item.dateOfPurchase,
          paid: Number(paid) || 0,
          steelWeightKgSale: item?.steelWeightKgSale,
        };
        console.log("copy", copyItems);
        console.log("   itemPrice ", itemPrice);

        saveSales.push(sale);
        if (state.ledger_id != "new") {
          let ledgerHis = {
            company_code: companyCode,
            ledger_id: state.ledger_id,
            ledgerType: "sale",
            item_id: item.itemId,
            itemName: item.name,
            itemPrice: itemPrice,
            sale_quantity: saleQty,
          };
          ledgerHistories.push(ledgerHis);
        }

        if (boxes) {
          let newItem = {
            _id: item._id,
            saleQuantity: saleQty + bonusQty,
            salePrice: itemPrice,
            boxes: boxes,
            saleType: item.saleType,
            saleBatchNumber: item?.saleBatchNumber,
          };
          console.log("newItem", newItem.saleQuantity);

          updatedItems.push(newItem);
        } else {
          if (foundBatch()) {
            if (item.batchNo) {
              console.log("itemmmm", item);
              let newItem = {
                _id: item._id,
                saleType: item.saleType,
                saleQuantity: saleQty + bonusQty,
                salePrice: itemPrice,
                batchNo: item.batchNo,
                saleBatchNumber: item?.saleBatchNumber,
              };
              console.log("newItem", newItem.saleQuantity);

              updatedItems.push(newItem);
            } else {
              let newItem = {
                _id: item._id,
                saleQuantity: Number(saleQty) + Number(bonusQty),
                salePrice: itemPrice,
                saleType: item.saleType,
                saleBatchNumber: item?.saleBatchNumber,
              };
              console.log("newItem", newItem);

              console.log("newItem", newItem.saleQuantity);
              console.log("itemmmmelse", item);

              updatedItems.push(newItem);
            }
          } else {
            let newItem = {
              _id: item._id,
              // saleQuantity: saleQty + bonusQty,
              saleQuantity: saleQty,

              salePrice: itemPrice,
              saleType: item.saleType,
              saleBatchNumber: item?.saleBatchNumber,
            };
            console.log("bonus", bonusQty);
            console.log("bonus", saleQty);

            console.log("newItem", newItem.saleQuantity);

            updatedItems.push(newItem);
          }
        }
        console.log("UpdateItem");
        let updateItem = {
          ...item,
          company_code: companyCode,
        };

        if (item.weightType == true) {
          updateItem.weight = parseFloat(item.weight - saleQty);
        } else {
          updateItem.quantity = parseFloat(item.quantity - saleQty);
        }

        billItems.push(
          JSON.parse(
            JSON.stringify({
              ...updateItem,
              saleQuantity: saleQty,
              salePrice: itemPrice,
            })
          )
        );

        if (qty - saleQty - minQuantity <= 0) {
          toast.configure();
          toast.warn(item.name + " is out of stock");
          let notification = {
            _id: item._id,
            data: "Its time to re order " + item.name + " stock again!",
            timestamp: Math.floor(Date.now() / 1000),
            read: "false",
            category: item.category,
            unit: item.unit,
            name: item.name,
            quantity: item.quantity,
            description: item.description,
            imgName: item.imgName,
            discount: item.discount,
            imgURL: item.imgURL,
            itemId: item.itemId,
            minQuantity: minQuantity,
            company_code: companyCode,
            price: item.price,
            itemCode: item.itemCode,
            vendor: item.vendor,
            dateOfPurchase: item.dateOfPurchase,
            costPrice: item.costPrice,
            rack_code: item.rack_id,
            companyPrice: item.companyPrice,
            whole_sale_price: item.whole_sale_price,
            sub_rack_code: item.sub_rack_code,
            weight: item.weight,
            weightType: item.weightType,
            shop_stock: item.shop_stock,
          };

          if (item.weightType) {
            notification.weight = parseFloat(item.weight - saleQty);
          } else {
            notification.quantity = parseFloat(item.quantity - saleQty);
          }
          noti.push(notification);
          dispatch(addToSelectForPurchase(noti));
        }
      });
    console.log("log", state);
    console.log("billItems",  billItems);

    // console.log("logOne", state);
    const startTime = performance.now();
      let  totalValue = state.Total + state.formallyOutstandings;

    let id = uuidv4();
    let _id = id.replaceAll("-", "");
    if (state.new_ledger.name != "" && state.new_ledger.address != "") {
      console.log("no");
      Promise.all([
        createLedger(_id, state.new_ledger, dispatch),
        createBill(
          billItems,
          thisDate,
          billNumber,
          state,
          _id,
          type,
          templateType,
          state.storeBill,
          state.paymentMethod,
          state.bank,
          state.cheque,
          status,
          state.bankId

        ),
      ])
        .then((values) => {
          const billsresponseId = values
            .map((item) => item.data.response.data.bill)
            .join();
          console.log("billsresponse", billsresponseId);
          console.log("valuesss", values);
          const endTime = performance.now(); // Record the end time
          const responseTime = endTime - startTime;
          if (state.paid > 0) {
            if(state.paymentMethod == "cash") {
              saveInCashInHand(
                billItems,
                thisDate,
                billNumber,
                state,
                _id,
                type,
                templateType,
                state.storeBill,
                state.paymentMethod,
                state.bank,
                state.cheque,
                status,
                billsresponseId
              );
            } else {
              saveInBank(
                billItems,
                thisDate,
                billNumber,
                state,
                _id,
                type,
                templateType,
                state.storeBill,
                state.paymentMethod,
                state.bank,
                state.cheque,
                status,
                billsresponseId,
                state.bankId
              );
            }
           
          }

          // Check if response time exceeds 20 seconds
          if (responseTime > 20000) {
            // 20000 milliseconds = 20 seconds
            console.log("emaillll");
            sendEmailNotification("saveBill");
          }
          let paid = 0;
          if (state.paid > state.Total) {
            paid = state.Total;
          } else {
            paid = state.paid;
          }
          updateSaleLedger(_id, billNumber, paid, state.Total,totalValue);
          dispatch(getItems());

          toast.configure();
          toast.success("Ledger, Entry & Bill Created");
        })
        .catch((err) => {
          console.log(err);
          toast.configure();
          toast.error("Ledger, Entry & Bill Not Created");
        });
    } else {
      if (state.ledger_id == "new") {
        
        Promise.all([
          createBill(
            billItems,
            thisDate,
            billNumber,
            state,
            "",
            type,
            billTemplate,
            state.storeBill,
            state.paymentMethod,
            state.bank,
            state.cheque,
            status,
            state.bankId

          ),
        ])
          .then((values) => {
            console.log("valuesss", values);
            const billsresponseId = values
              .map((item) => item.data.response.data.bill)
              .join();
            console.log("billsresponse", billsresponseId);
            const endTime = performance.now(); // Record the end time
            const responseTime = endTime - startTime;
            if (state.paid > 0) {
              if(state.paymentMethod == "cash") {

              saveInCashInHand(
                billItems,
                thisDate,
                billNumber,
                state,
                _id,
                type,
                templateType,
                state.storeBill,
                state.paymentMethod,
                state.bank,
                state.cheque,
                status,
                billsresponseId
              );
            } else  {
              saveInBank(
                billItems,
                thisDate,
                billNumber,
                state,
                _id,
                type,
                templateType,
                state.storeBill,
                state.paymentMethod,
                state.bank,
                state.cheque,
                status,
                billsresponseId,
                state.bankId

              );
            }
          }

            // Check if response time exceeds 20 seconds
            if (responseTime > 20000) {
              // 20000 milliseconds = 20 seconds
              sendEmailNotification("saveBill");
            }
            dispatch(getItems());
          })
          .catch((err) => {
            console.log(err);
            toast.configure();
            toast.error("Bill Not Created");
          });
      } else {
        let extraAmount = 0;
        let paid = 0;
        let totalValue = 0;
        if (state.clearBalance) {
          if (state.paid > state.Total) {
            extraAmount = Number(state.paid - state.Total);
            // extraAmount =   Math.abs(Number(state.formallyOutstandings));
            console.log("extra", extraAmount);
            // paid = state.Total;
            paid = state.paid;
          }
          // else {
          //   paid = state.paid;
          // }
        } else {
          paid = state.paid;
        }
        totalValue = state.Total + state.formallyOutstandings;
        console.log("totalvalue", totalValue);
        if (extraAmount) {
          console.log("extra", state);
          console.log("extraTotal", state.Total);

          Promise.all([
            createBill(
              billItems,
              thisDate,
              billNumber,
              state,
              state.ledger_id,
              type,
              billTemplate,
              state.storeBill,
              state.paymentMethod,
              state.bank,
              state.cheque,
              status,
              state.bankId,
              state.clearBalance

            ),
            updateSaleLedger(state.ledger_id, billNumber, paid, state.Total, totalValue, state.clearBalance),

          ])
            .then((values) => {
              console.log("valuesss", values);
              const billsresponseId = values
                .map((item) => item.data.response.data.bill)
                .join();

              console.log("billsresponse", billsresponseId);
              const endTime = performance.now(); // Record the end time
              const responseTime = endTime - startTime;
              if (state.paid > 0) {
                if(state.paymentMethod == "cash") {

                saveInCashInHand(
                  billItems,
                  thisDate,
                  billNumber,
                  state,
                  _id,
                  type,
                  templateType,
                  state.storeBill,
                  state.paymentMethod,
                  state.bank,
                  state.cheque,
                  status,
                  billsresponseId,
                  state.clearBalance
                );
              } else {
                saveInBank(
                  billItems,
                  thisDate,
                  billNumber,
                  state,
                  _id,
                  type,
                  templateType,
                  state.storeBill,
                  state.paymentMethod,
                  state.bank,
                  state.cheque,
                  status,
                  billsresponseId,
                  state.bankId,
                  state.clearBalance


                );
              }
              }

              // Check if response time exceeds 20 seconds
              if (responseTime > 20000) {
                // 20000 milliseconds = 20 seconds
                sendEmailNotification("saveBill");
              }
              // createLedgerEntry(state.ledger_id, extraAmount,state.formallyOutstandings);
              dispatch(getItems());
            })
            .catch((err) => {
              console.log(err);
              toast.configure();
              toast.error("Bill & Ledger Entry Not Created");
            });
        } else {
          console.log("elllse");
         let totalValue = state.Total + state.formallyOutstandings;

          Promise.all([
            createBill(
              billItems,
              thisDate,
              billNumber,
              state,
              state.ledger_id,
              type,
              billTemplate,
              state.storeBill,
              state.paymentMethod,
              state.bank,
              state.cheque,
              status,
              state.bankId
            ),
            updateSaleLedger(state.ledger_id, billNumber, paid, state.Total,totalValue),
          ])
            .then((values) => {
              console.log("valuesss", values);
              const billsresponseId = values
                .map((item) => item.data.response.data.bill)
                .join();

              console.log("billsresponse", billsresponseId);
              const endTime = performance.now(); // Record the end time
              const responseTime = endTime - startTime;
              if (state.paid > 0) {
                if(state.paymentMethod == "cash") {

                saveInCashInHand(
                  billItems,
                  thisDate,
                  billNumber,
                  state,
                  _id,
                  type,
                  templateType,
                  state.storeBill,
                  state.paymentMethod,
                  state.bank,
                  state.cheque,
                  status,
                  billsresponseId
                );
              } else {
                saveInBank(
                  billItems,
                  thisDate,
                  billNumber,
                  state,
                  _id,
                  type,
                  templateType,
                  state.storeBill,
                  state.paymentMethod,
                  state.bank,
                  state.cheque,
                  status,
                  billsresponseId,
                  state.bankId

                );
              }
              }

              // Check if response time exceeds 20 seconds
              if (responseTime > 20000) {
                // 20000 milliseconds = 20 seconds
                sendEmailNotification("saveBill");
              }
              dispatch(getItems());
            })
            .catch((err) => {
              console.log(err);
              toast.configure();
              toast.error("Bill & Ledger Entry Not Created");
            });
        }
      }
    }
    dispatch(saleQuantity(updatedItems));
    console.log("updatedItems", updatedItems);
    console.log("saveSales", saveSales);

    if (ledgerHistories.length > 0 && noti.length > 0) {
      Promise.all([
        P1(saveSales),
        P3(updatedItems),
        P2(ledgerHistories),
        P4(noti),
      ]);
    } else if (ledgerHistories.length > 0 && noti.length == 0) {
      Promise.all([P1(saveSales), P3(updatedItems), P2(ledgerHistories)]);
    } else if (ledgerHistories.length == 0 && noti.length > 0) {
      Promise.all([P1(saveSales), P3(updatedItems), P4(noti)]);
    } else {
      Promise.all([P1(saveSales), P3(updatedItems)]);
    }
    dispatch(removeSelected());
    dispatch(clearLedgersNames());
    dispatch(unselectItems());

    setTimeout(() => {
      if (tokenType == "admin") {
        history.push("/inventory/admin/outgoing");
      } else {
        history.push("/inventory/dashboard/outgoing");
      }
    }, 300);
  };

  function onClickYes() {
    if (templateType == "warehouse") {
      warehouseSale();
    } else {
      sellItems();
    }
  }

  const warehouseSale = async () => {
    let thisDate = moment().format("DD-MM-YYYY");
    const billTemplate = localStorage.getItem("template");
    let copyItems = JSON.parse(JSON.stringify(selectedForSale));
    setState((pre) => ({ ...pre, loading: true }));

    let updatedItems = [];
    copyItems &&
      copyItems.forEach((item) => {
        let saleQty = item.saleQuantity ? item.saleQuantity : 1;
        console.log("item", item);
        if (foundBatch()) {
          if (item.batchNo) {
            let newItem = {
              _id: item._id,
              saleQuantity: saleQty,
              batchNo: item.batchNo,
              saleType: item.saleType,
            };
            console.log("newItem", newItem.saleQuantity);
            updatedItems.push(newItem);
          }
        } else {
          let newItem = {
            _id: item._id,
            saleQuantity: saleQty,
            saleType: item.saleType,
          };
          console.log("newItem", newItem.saleQuantity);
          updatedItems.push(newItem);
        }
      });
    dispatch(saleQuantity(updatedItems));
    dispatch(unselectItems());
    dispatch(removeSelected());
    Promise.all([
      saleWarhouse(warehouseNumber, copyItems, thisDate),
      mutateItems(updatedItems, dispatch, copyItems),
    ]);
    dispatch(increaseWareNumber());
    setState((pre) => ({ ...pre, loading: false }));
    history.push("/inventory/admin/outgoing");
  };

  const toggleQuotation = () => {
    if (!state.customer) {
      Toast("info", "Provide Customer Name");
      return;
    }
    handleBill("true");
  };

  const calculateDiscount = (value, type, subTotal) => {
    console.log("value", value);
    console.log("subTotal", subTotal);
    if (type == "price") {
      if (parseInt(value) > parseInt(subTotal)) {
        Toast("info", "Cant have discounts more than Total Price");
      } else {
        setState((pre) => ({ ...pre, discAmount: value }));
      }
    } else if (type == "percentage") {
      if (value < 90) {
        let discount = (subTotal / 100) * value;
        setState((pre) => ({ ...pre, discAmount: discount }));
      } else {
        Toast("info", "Cant have discounts more than 90%");
        setState((pre) => ({ ...pre, discAmount: 0 }));
      }
    }
  };
  const getBanksListHandler = async () => {
    const banks = await getBanksList();
    console.log("bankss", banks);
    setBanksList(banks);

    return banks;
  };
  const saleNow = () => {
    if (selectedForSale.length == 0) {
      Toast("info", "No Items Selected");
      return;
    }
    //  if ((state.paid - (getTotal() % 1) === 0
    // ? state.paid - getTotal()
    // :
    // (state.paid - getTotal()).toFixed(3)) > 0){
    //    Toast("info", "Paid Amount Cannot Be Greater Than Total Amount");
    //    return;
    // }
    console.log("selected", selectedForSale);

    const emptySaleType = selectedForSale.find((foundItem) => foundItem);
    console.log("emptysaletype", emptySaleType);

    const stockValueName = selectedForSale.find(
      (foundItem) =>
       ( foundItem.quantity <= 0 || foundItem.saleQuantity > foundItem.quantity )? foundItem.name : ''
  );


    console.log("stockVlaue", stockValueName);
    if (company.stockValue == "yes" && stockValueName ) {
      Toast("info", `Out Of Stock ${stockValueName.name} Cannot Be Sold More Than Its Stock`);
      return;
    }


    const costSaleComp = selectedForSale.find(
      (foundItem) =>
        Number(foundItem.salePrice ? foundItem.salePrice : foundItem.price) <
        Number(foundItem.costPrice)
    );
    console.log("costSaleComp", costSaleComp);

    // if (costSaleComp) {
    //   Toast("info", `Cost Price Cannot Be Less Than Sale Price`);
    //   return;
    // }
    if (emptySaleType.saleType == "") {
      Toast("info", "No SaleType Selected");
      return;
    }

    console.log("emppp", emptySaleType);
    if (state.customer) {
      const emptyPrice = selectedForSale.find(
        (foundItem) =>
          (foundItem.salePrice == "" ||
            foundItem.salePrice == undefined ||
            foundItem.salePrice == 0 ||
            foundItem.salePrice == "NaN") &&
          (foundItem.price == "" ||
            foundItem.price == undefined ||
            foundItem.price == 0 ||
            foundItem.price == "NaN") &&
          (foundItem.batchPricePerBox == "" ||
            foundItem.batchPricePerBox == undefined ||
            foundItem.batchPricePerBox == 0 ||
            foundItem.batchPricePerBox == "NaN") &&
          (foundItem.batchPricePerBox == "" ||
            foundItem.batchPricePerBox == undefined ||
            foundItem.batchPricePerBox == 0 ||
            foundItem.batchPricePerBox == "NaN")
      );
      
      if(state.paymentMethod == "bank" && state.bankId == ""){
        Toast("info", "Please Select Bank");
        return;
      }
      if (emptyPrice) {
        Toast("info", "Sale Price cannot be empty");
        return;
      }
      const noQty = selectedForSale.find(
        (i) => i.saleQuantity == "" || i.saleQuantity == 0
      );
      if (noQty) {
        Toast("info", "Provide Sale Quantity");
        return;
      }

      if (billNumber === "") {
        getBill();
        toast.configure();
        toast.info("Regenerating bill number try again");
        return;
      }
      handleBill("false");
    } else {
      toast.configure();
      toast.info("Provide Customer Name");
    }
  };

  const warehouseOnly = () => {
    handleBill("false");
  };

  const handleLedger = (e, val) => {
    if (val) {
      let saleTotal = 0;
      if (val?.saleTotal) {
        saleTotal = val.saleTotal;
      } else {
        saleTotal = 0;
      }
      setState((pre) => ({
        ...pre,
        customer: val.name || pre.customer,
        formallyOutstandings: saleTotal,
        idString: val,
        ledger_id: val._id,
        ledger_address: val.address,
      }));
    } else {
      setState((pre) => ({
        ...pre,
        customer: "",
        formallyOutstandings: 0,
        idString: "new",
        ledger_id: "new",
      }));
    }
  };

  const handleNewLedger = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    if (name == "name") {
      setState((pre) => ({
        ...pre,
        customer: value,
        new_ledger: {
          ...pre.new_ledger,
          [name]: value,
        },
      }));
    } else {
      setState((pre) => ({
        ...pre,
        new_ledger: {
          ...pre.new_ledger,
          [name]: value,
        },
      }));
    }
  };

  const handleSelection = () => {
    setState((pre) => ({
      ...pre,
      ledgerSelection: !pre.ledgerSelection,
      customer: "",
      ledger_id: "new",
      idString: "new",
      formallyOutstandings: 0,
    }));
  };
  const handleBack = () => {
    setState((pre) => ({
      ...pre,
      ledgerSelection: false,
      new_ledger: {
        ledger_type: "customer",
        address: "",
        name: "",
      },
    }));
  };
  const handleInput = (e) => {
    let name = e.target.name;
    console.log("name", name);
    console.log("valuee", e.target.value);

    let value;
    let newVal;
    if (name == "clearBalance") {
      value = e.target.checked;
    } else if (name === "storeBill") {
      value = true;
      saleNow();
    } else if (name == "bank") {
      newVal = e.target.value;

      value = newVal.bankName;
      console.log("value", value);
    } else {
      value = e.target.value;
    }

    if (name == "bank") {
      setState((pre) => ({
        ...pre,
        [name]: value,
        bankId: e.target.value._id,
      }));
    } else {
      setState((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
  };

  const toggle = (name) => {
    setState((pre) => ({
      ...pre,
      [name]: !pre[name],
    }));
  };

  const handleDiscountType = (e = "") => {
    handleInput(e);
    console.log("handlediscount", state.subTotal);
    calculateDiscount(state.discount, e.target.value, state.subTotal);
  };
  const handleDiscount = (e) => {
    handleInput(e);
    let value = e.target.value;
    calculateDiscount(value, state.discountType, state.subTotal);
    console.log("value", value);
    // console.log("subTotal", subTotal);
  };
  const handleCancelSale = () => {
    dispatch(removeSelected());
    dispatch(unselectItems());
    history.push("/inventory/admin/outgoing/");
  };

  const getTotal = () => {
    let total = 0;
    if (state.clearBalance || state.varTotal) {
      total =
        Number(state.Total) +
        Number(state.formallyOutstandings) +
        Number(state.varTotal);
    } else {
      console.log("elseeeeeee");
      total = Number(state.Total);
    }
    console.log("total", total);
    return total % 1 === 0 ? total : total.toFixed(3);
  };

  const headRow = ["Item", "Item Name", "Quantity", "Unit Price", "Date"];
  const tableBody = [
    `ledgerType`,
    `itemName`,
    `sale_quantity`,
    `itemPrice`,
    `created_at`,
  ];

  const foundBatch = () => {
    let found = selectedForSale.find((item) => {
      if (item?.batchNumber && item?.batchNumber.length > 0) {
        return item;
      }
    });

    if (found) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box sx={{ mt: 5, positon: "relative" }}>
      <Grid container>
        <GridBox item md={6} sm={12}>
          <Box textAlign="center">
            {state.ledgerSelection == false && (
              <Button
                sx={{
                  fontSize: { md: "16px", xs: "14px" },
                  mt: "8px",
                  lineHeight: "120%",
                  textTransform: "none",
                  padding: "0px",
                }}
                onClick={handleSelection}
                className="ledger-font-sm-10"
              >
                New Ledger
              </Button>
            )}
            {state.ledgerSelection == true && (
              <BtnBack onClick={handleBack}>Back</BtnBack>
            )}
          </Box>
          <Box>
            {state.ledgerSelection == true && (
              <>
                <h4 style={{ margin: "0 auto", padding: "10px" }}>
                  Create new ledger
                </h4>
                {state.ledger_id === "new" && (
                  <TextField
                    size="small"
                    variant="outlined"
                    required
                    name="name"
                    value={state.new_ledger.name}
                    onChange={handleNewLedger}
                    placeholder="Create Ledger Name"
                  />
                )}

                {state.ledger_id === "new" && (
                  <TextField
                    size="small"
                    variant="outlined"
                    value={state.new_ledger.address}
                    required
                    name="address"
                    onChange={handleNewLedger}
                    placeholder="Enter Detail"
                  />
                )}
              </>
            )}

            {state.ledgerSelection != true && (
              <Box style={{ marginTop: "20px" }}>
                <Autocomplete
                  autoFocus
                  size="small"
                  onChange={(e, val) => {
                    handleLedger(e, val);
                  }}
                  getOptionLabel={(option) => option?.name || ""}
                  id="controllable-states-demo"
                  options={ledgersNames}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoFocus
                      label="Ledger"
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  )}
                />
                {state.ledger_id != "" && state.ledger_id != "new" && (
                  <BtnHistory
                    fullWidth
                    size="small"
                    variant="contained"
                    onClick={historyToggle}
                  >
                    View item sale history
                    {state.historyModal && (
                      <VisibilityIcon style={{ marginLeft: "20px" }} />
                    )}
                    {!state.historyModal && (
                      <VisibilityOffIcon style={{ marginLeft: "20px" }} />
                    )}
                  </BtnHistory>
                )}
              </Box>
            )}
          </Box>
          <Box sx={{ ml: { md: "10px", xs: "20px" } }}>
            <TextField
              variant="outlined"
              multiline
              minRows={3}
              maxRows={8}
              value={state.notes}
              name="notes"
              onChange={handleInput}
              placeholder="Sale notes"
              sx={{ margin: 1, width: "90%", padding: "5px" }}
            />
          </Box>
        </GridBox>
        <Grid item lg={5} md={5} sm={12} xs={12} className="profit-class">
          <ClickAreaBox align="center" id="box-overflow">
            {state.yourProfit == true && (
              <>
                <BtnHeader onClick={() => toggle("yourProfit")}>
                  Profit
                </BtnHeader>

                {selectedForSale.map((item, i) => {
                  let itemPrice = item.salePrice ? item.salePrice : item.price;
                  let saleQty = item.saleQuantity ? item.saleQuantity : 1;
                  return (
                    <div key={i} style={{ marginTop: "10px" }}>
                      <b className="regular-font-8"> {item.name} </b>{" "}
                      <span className="profit is">profit is</span>:{" "}
                      <b className="regular-font-8">
                        {" "}
                        {itemPrice == item.costPrice
                          ? 0
                          : (parseInt(itemPrice) - parseInt(item.costPrice)) *
                            saleQty}
                      </b>
                    </div>
                  );
                })}
                <BtnBack onClick={() => toggle("yourProfit")}>Back</BtnBack>
              </>
            )}
            {state.yourProfit != true && (
              <BtnHeader onClick={() => toggle("yourProfit")}>
                Click to see your Profit
              </BtnHeader>
            )}
          </ClickAreaBox>
          {/* <ClickAreaBox align="center">
            {state.saleKhata == true && (
              <>
                <BtnHeader onClick={() => toggle("saleKhata")}>
                  Sale Khata
                </BtnHeader>

                <p
                  style={{
                    marginTop: "30px",
                    textAlign: "center",
                  }}
                >
                  <b>
                    {JSON.stringify(
                      ledgersNames.find((item) => item._id == state.ledger_id)
                        ?.saleTotal || 0
                    )}
                  </b>
                </p>
                <BtnBack onClick={() => toggle("saleKhata")}>Back</BtnBack>
              </>
            )}
            {state.saleKhata != true && (
              <BtnHeader onClick={() => toggle("saleKhata")}>
                Click Sale Khata
              </BtnHeader>
            )}
          </ClickAreaBox> */}
          <Box>
            <FormControl fullWidth margin="normal">
              <InputLabel
                sx={{
                  // top: '50%',
                  transform: "translateY(-50%)",
                  fontSize: "0.8em",
                }}
              >
                Payment Method
              </InputLabel>
              <Select
                disablePortal
                sx={{
                  height: "2.4em", // Adjusted height
                  fontSize: "0.8em",
                  // display: "flex",
                  // alignItems: "center",
                }}
                value={state.paymentMethod}
                onChange={handleInput}
                label="Payment Method"
                name="paymentMethod"
              >
                <MenuItem value="cash">Cash</MenuItem>
                <MenuItem value="bank">Bank</MenuItem>
                { <MenuItem value="cheque">Cheque</MenuItem> }
              </Select>
            </FormControl>

            {state.paymentMethod === "cheque" && (
              <TextField
                name="cheque"
                type="number"
                value={state?.cheque}
                onChange={handleInput}
                InputProps={{
                  sx: {
                    label: "Cheque No",
                    name: "cheque",
                    padding: "0 !important", // Adjust padding to reduce the height
                    height: "2em !important", // Set height
                  },
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "2em", // Set root height
                  },
                  "& .MuiInputBase-input": {
                    padding: "0 !important", // Override input padding
                  },
                }}
              />
            )}

            {state.paymentMethod === "bank" && (
              <FormControl fullWidth margin="normal">
                <InputLabel
                  sx={{
                    // top: '50%',
                    transform: "translateY(-50%)",
                    fontSize: "0.8em",
                  }}
                >
                  Bank
                </InputLabel>
                <Select
                  disablePortal
                  sx={{
                    height: "2.4em", // Adjusted height
                    fontSize: "0.8em",
                    display: "flex",
                    alignItems: "center",
                    mt: "0px",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: "200px", // Set max height for scrollable menu
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null, // Prevents menu from appearing on top
                  }}
                  value={state.bank}
                  onChange={handleInput}
                  label="Bank"
                  name="bank"
                >
                  {banksList.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item.bankName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        </Grid>
      </Grid>

      <div className="sale-grid" id="Table">
        <TabOrderComponent state={state} />
        <div
          style={{ backgroundColor: "#F5FFF6" }}
          className="total-container"
          id="table"
        >
          {templateType == "warehouse" && (
            <Button
              style={{
                backgroundColor: "#F79696",
                color: "white",
                marginTop: "25px",
              }}
              variant="contained"
              onClick={warehouseOnly}
            >
              Create Warehouse
            </Button>
          )}

          {templateType != "warehouse" && (
            <>
              <div className="finances-flex">
                <h4>Sub Total:</h4>
                <h4 className="no-mg prices regular">
                  {/* {state.subTotal.toFixed(2)} */}
                  {state.subTotal % 1 === 0
                    ? state.subTotal
                    : state.subTotal.toFixed(3)}
                </h4>
              </div>
              <div className="finances-flex">
                <h4 style={{ margin: "0px", padding: "0px" }}>
                  Previous Balance:
                </h4>
                <input
                  className="input-outstandings"
                  value={state.formallyOutstandings}
                  name="formallyOutstandings"
                  type="number"
                  onChange={handleInput}
                />
              </div>
              {state.ledger_id && state.ledger_id != "new" && (
                <div
                  className="finances-flex"
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <h4 style={{ margin: "0px", padding: "0px" }}>
                    Clear Balance:
                  </h4>
                  <input
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                    // className="input-outstandings"
                    value={state.clearBalance}
                    name="clearBalance"
                    type="checkbox"
                    onChange={handleInput}
                  />
                </div>
              )}
              <hr></hr>

              <div className="finances-flex">
                <h3 className="no-mg regular">Discount:</h3>
                <select
                  disabled={state.discount == 0}
                  style={{ maxHeight: "39px", borderRadius: "8px" }}
                  name="discountType"
                  onChange={handleDiscountType}
                >
                  <option value="price">Price</option>
                  <option value="percentage">Percentage</option>
                </select>
                <input
                  className="input-finances prices no-mg regular"
                  type="number"
                  min="0"
                  name="discount"
                  value={state.discount}
                  max={state.discount}
                  onChange={handleDiscount}
                />
              </div>
              {companyCode == "1916" ? (
                <>
                  <hr></hr>
                  <div className="finances-flex">
                    <h4 style={{ margin: "0px", padding: "0px" }}>
                      VAT Total:
                    </h4>
                    <input
                      className="input-outstandings"
                      value={state.varTotal}
                      name="varTotal"
                      type="number"
                      onChange={handleInput}
                    />
                  </div>
                </>
              ) : (
                ""
              )}
              {gst &&
                gst !== "disabled" &&
                gst !== "undefined" &&
                gstType === "Bill" && (
                  <div className="finances-flex">
                    <h3 className="no-mg regular">GST:</h3>
                    <h4 className="no-mg prices regular">
                      {gst !== "undefined" ? gst : 0}%
                    </h4>
                  </div>
                )}

              <hr></hr>

              {income && income !== "undefined" && income !== "disabled" && (
                <>
                  <div className="finances-flex">
                    <h3 className="no-mg regular">Income tax:</h3>
                    <h4 className="no-mg prices regular">
                      {income !== "undefined" ? income : 0}%
                    </h4>
                  </div>
                  <hr />
                </>
              )}

              {further && further !== "undefined" && further !== "disabled" && (
                <>
                  <div className="finances-flex">
                    <h3 className="no-mg regular">Further Tax:</h3>
                    <h4 className="no-mg prices regular">
                      {further !== "undefined" ? further : 0}%
                    </h4>
                  </div>
                  <hr />
                </>
              )}

              <div className="finances-flex">
                <h3 className="no-mg regular">Total:</h3>
                <h3 className="no-mg prices regular">{getTotal()}</h3>
              </div>
              <hr></hr>

              <div className="finances-flex-bottom">
                <div style={{ paddingBottom: "-5px" }}>
                  <h4 style={{ marginTop: "-3px" }}>PAID:</h4>

                  <input
                    style={{ marginTop: "-3px" }}
                    className="input-paid prices no-mg regular"
                    value={state.paid}
                    name="paid"
                    type="number"
                    min="0"
                    onChange={handleInput}
                  />
                </div>
                <hr className="hrule"></hr>
                <div style={{ marginBottom: "-5px" }}>
                  <h4 style={{ marginTop: "-3px" }}>Balance:</h4>
                  {RFTfeature() && state.saleType == "service" ? (
                    <h4
                      className="no-mg prices regular"
                      style={{ marginTop: "-3px" }}
                    >
                      {currency} {state.paid - getTotal()}
                    </h4>
                  ) : (
                    <h4
                      className="no-mg prices regular"
                      style={{ marginTop: "-3px" }}
                    >
                      {currency}:{" "}
                      {state.paid - (getTotal() % 1) === 0
                        ? state.paid - getTotal()
                        : (state.paid - getTotal()).toFixed(3)}
                    </h4>
                  )}
                </div>
              </div>
              <hr />

              <div className="flex">
                <h3 style={{ marginLeft: "15px" }} className="no-mg regular">
                  Customer:{" "}
                </h3>
                <input
                  className="prices no-mg regular"
                  type="text"
                  style={{
                    border: "1px solid black",
                    width: "150px",
                    marginLeft: "40px",
                    marginTop: "3px",
                  }}
                  value={state.customer}
                  name="customer"
                  onChange={handleInput}
                />
              </div>
              <hr />
              <div>
                <div className="center">
                  {state.loading == true && (
                    <ClipLoader
                      size={50}
                      color="#4DAF51"
                      loading={state.loading}
                    />
                  )}

                  <>
                    {state.loading == false && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#F79696 !important",
                          color: "white",
                          mr: 1,
                          textTransform: "none",
                        }}
                        onClick={handleCancelSale}
                      >
                        Cancel Sale
                      </Button>
                    )}
                    {state.loading == false && (
                      <Button
                        variant="contained"
                        style={{
                          color: "white",
                          backgroundColor: "#4EAF51",
                        }}
                        onClick={saleNow}
                      >
                        Sale
                      </Button>
                    )}

                    {(companyCode == "2099" || companyCode == "3388") &&
                      state.loading == false && (
                        <Button
                          variant="contained"
                          style={{
                            color: "white",
                            backgroundColor: "#4EAF51",
                          }}
                          value={state.storeBill}
                          name="storeBill"
                          onClick={handleInput}
                        >
                          Store Bill
                        </Button>
                      )}

                    {state.paid == "" && state.loading == false && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <BtnQuote variant="contained" onClick={toggleQuotation}>
                          Quotation
                        </BtnQuote>
                      </Box>
                    )}
                  </>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <BillPreview
        title="Bill Preview"
        open={state.showBill}
        onSale={onClickYes}
        onQuotation={sellQuotation}
        onClose={() => toggle("showBill")}
        onClickCancel={() => toggle("showBill")}
        bill={state.propsBill}
        sellItem={true}
        storeBill={state.storeBill}
        fivePercent="saleItem"
      />
      <DialogComponent
        title="Item History"
        open={state.historyModal}
        onClose={historyToggle}
        dialogContent={
          <TableComponent
            headRow={headRow}
            rows={state.itemHistory}
            tableBody={tableBody}
          />
        }
      />
      <DialogComponent
        title="Add Item"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        dialogContent={
          <AddItem onClose={() => toggle("addModal")} sale="true" />
        }
      />
      <div className="centralize-loader">
        <ClipLoader size={50} color={"#4DAF51"} loading={state.loading} />
      </div>
    </Box>
  );
}

export default SellItem;
